import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export interface useBuscarLeadInterface {
  params: string;
  LeadsProprios: boolean;
}

export function useExportarLeads(
  props: useBuscarLeadInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const EXPORTAR_LEADS = `${leadsWebEnviroment}/commom/leads/exportar-leads/v1?LeadsProprios=${props?.LeadsProprios}${props?.params}`;
    const response = await instance.get(EXPORTAR_LEADS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    cacheTime: 0,
    onError: (error: any) => {
      toast.error(
        `Erro ao exportar leads. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
